export class User {

    constructor(public sub :string| null, public email: string| null, public phone : string| null,public account: string| null, public admin: any| null, public scopes: string| null, public token: string| null, public tickets?: any) {
    
    }
}